export enum SubChartType {
    /** 未知 */
    Unknown = 0,
    AreaChart = 1,
    Area3DChart = 2,
    LineChart = 3,
    Line3DChart = 4,
    StockChart = 5,
    RadarChart = 6,
    ScatterChart = 7,
    PieChart = 8,
    Pie3DChart = 9,
    DoughnutChart = 10,
    BarChart = 11,
    Bar3DChart = 12,
    OfPieChart = 13,
    SurfaceChart = 14,
    Surface3DChart = 15,
    BubbleChart = 16,
}

export enum STDLblPos {
    PBDEFAULT = 0,
    bestFit = 1,
    b = 2,
    ctr = 3,
    inBase = 4,
    inEnd = 5,
    l = 6,
    outEnd = 7,
    r = 8,
    t = 9,
}

export enum STBuiltInUnit {
    PBDEFAULT = 0,
    hundreds = 1,
    thousands = 2,
    tenThousands = 3,
    hundredThousands = 4,
    millions = 5,
    tenMillions = 6,
    hundredMillions = 7,
    billions = 8,
    trillions = 9,
}

export enum STTrendlineType {
    PBDEFAULT = 0,
    exp = 1,
    linear = 2,
    log = 3,
    movingAvg = 4,
    poly = 5,
    power = 6,
}

export enum STOrientationDmlC {
    PBDEFAULT = 0,
    maxMin = 1,
    minMax = 2,
}

export enum STBarDir {
    PBDEFAULT = 0,
    bar = 1,
    col = 2,
}

export enum STAxPos {
    PBDEFAULT = 0,
    b = 1,
    l = 2,
    r = 3,
    t = 4,
}

export enum STLayoutMode {
    PBDEFAULT = 0,
    edge = 1,
    factor = 2,
}

export enum STLegendPos {
    PBDEFAULT = 0,
    b = 1,
    tr = 2,
    l = 3,
    r = 4,
    t = 5,
}

export enum STCrossBetween {
    PBDEFAULT = 0,
    between = 1,
    midCat = 2,
}

export enum STTickLblPos {
    PBDEFAULT = 0,
    high = 1,
    low = 2,
    nextTo = 3,
    none = 4,
}

export enum STLblAlgn {
    PBDEFAULT = 0,
    ctr = 1,
    l = 2,
    r = 3,
}

export enum STCrosses {
    PBDEFAULT = 0,
    autoZero = 1,
    max = 2,
    min = 3,
}

export enum STTickMark {
    PBDEFAULT = 0,
    cross = 1,
    in = 2,
    none = 3,
    out = 4,
}

export enum STMarkerStyleDmlC {
    PBDEFAULT = 0,
    circle = 1,
    dash = 2,
    diamond = 3,
    dot = 4,
    none = 5,
    picture = 6,
    plus = 7,
    square = 8,
    star = 9,
    triangle = 10,
    x = 11,
    auto = 12,
}

export enum STGrouping {
    PBDEFAULT = 0,
    percentStacked = 1,
    standard = 2,
    stacked = 3,
}

export enum STBarGrouping {
    PBDEFAULT = 0,
    percentStacked = 1,
    clustered = 2,
    standard = 3,
    stacked = 4,
}

export interface IEGAxis {
    /**
     * ```xml
     * <xsd:element typeRedirected=dmlchart:CT_ValAx maxOccurs="1" minOccurs="1" name="valAx" type="CT_ValAx">
     * ```
     */
    valAx?: any;
    /**
     * ```xml
     * <xsd:element typeRedirected=dmlchart:CT_CatAx maxOccurs="1" minOccurs="1" name="catAx" type="CT_CatAx">
     * ```
     */
    catAx?: any;
    /**
     * ```xml
     * <xsd:element typeRedirected=dmlchart:CT_DateAx maxOccurs="1" minOccurs="1" name="dateAx" type="CT_DateAx">
     * ```
     */
    dateAx?: any;
    /**
     * ```xml
     * <xsd:element typeRedirected=dmlchart:CT_SerAx maxOccurs="1" minOccurs="1" name="serAx" type="CT_SerAx">
     * ```
     */
    serAx?: any;
}

export enum STLayoutTarget {
    PBDEFAULT = 0,
    inner = 1,
    outer = 2,
}

export enum STSizeRepresents {
    PBDEFAULT = 0,
    area = 1,
    w = 2,
}

export enum STOfPieType {
    PBDEFAULT = 0,
    pie = 1,
    bar = 2,
}

export enum STSplitType {
    PBDEFAULT = 0,
    auto = 1,
    cust = 2,
    percent = 3,
    pos = 4,
    val = 5,
}

export enum STRadarStyle {
    PBDEFAULT = 0,
    standard = 1,
    marker = 2,
    filled = 3,
}

export enum STScatterStyle {
    PBDEFAULT = 0,
    none = 1,
    line = 2,
    lineMarker = 3,
    marker = 4,
    smooth = 5,
    smoothMarker = 6,
}

export enum STTimeUnit {
    PBDEFAULT = 0,
    days = 1,
    months = 2,
    years = 3,
}

export interface IValuePointData {
    /**
     * 对应 xsd中 XX.(NumRef | StrRef).xxCache.pt.v
     */
    v?: string;
    /**
     * 格式化代码
     */
    formatCode?: string;
}

export enum STSchemeColorVal {
    PBDEFAULT = 0,
    bg1 = 1,
    tx1 = 2,
    bg2 = 3,
    tx2 = 4,
    accent1 = 5,
    accent2 = 6,
    accent3 = 7,
    accent4 = 8,
    accent5 = 9,
    accent6 = 10,
    hlink = 11,
    folHlink = 12,
    phClr = 13,
    dk1 = 14,
    lt1 = 15,
    dk2 = 16,
    lt2 = 17,
}

export enum STDispBlanksAs {
    PBDEFAULT = 0,
    span = 1,
    gap = 2,
    zero = 3,
}

